import { API_URL } from "../../../constants";
import * as httpNetworking from "../../../httpNetworking";

const URL = API_URL + "/user/app";
const VERSION = 0;

export default async function buyNow(appId: string) {
    let options: httpNetworking.POSTRequestConfig = {
        timeout: 10000
    };

    const buyURL = `${URL}/${appId}/buy/now`;

    await httpNetworking.simplePOSTRequest(buyURL, {}, options, VERSION);
}
